import { Box, Typography } from '@mui/material'
import React from 'react'
import loadingGif from '../../../assets/images/mp_loading2.gif'

const RemovalStatsModal = () => {
  return (
      <Box
        sx={{
          position: 'absolute',
          top: '47%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: '#fff',
          p: 4,
          py: '96px',
          borderRadius: 10,
          overflowY: 'auto',
          width: '80%',
          height: '65%',
          textAlign: 'center',
          boxShadow: '0px 4px 46px 0px rgba(0, 0, 0, 0.12)',
        }}
      >
        {/* Loading Icon */}
        <Box
          component="img"
          src={loadingGif}
          alt="Loading"
          sx={{
            width: 145,
            height: 145,
            display: 'block',
            margin: '0 auto 24px auto',
          }}
        />
        {/* Main Heading */}
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: 31,
            lineHeight: '34px',
            color: '#3A155A',
            mb: '29px',
            mt: '25px'
          }}
        >
          Your scan is in progress
        </Typography>

        {/* Subtext */}
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: 25,
            lineHeight: '44px',
            color: '#6B7280',
          }}
        >
          This can take up to 24 hours.
          <br />
          We will email you when your results are complete.
        </Typography>
      </Box>

  )
}

export default RemovalStatsModal
